import QuickView from '../components/quickView';

Flickity.prototype._createResizeClass = function() {
  this.element.classList.add('flickity-resize');
};

Flickity.createMethods.push('_createResizeClass');

const resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
  this.element.classList.remove('flickity-resize');
  resize.call(this);
  this.element.classList.add('flickity-resize');
};

export default class Home {
  constructor() {
    this.quickViewModals = new QuickView('.modal');
    this.openQuickViewModalBtns = document.querySelectorAll('.quick-view button');
    this.heroCarousel = document.querySelectorAll('.home-hero .main-carousel');
    this.heroSection = document.querySelectorAll('.home-hero');
    this.heroVideoPopup = document.querySelectorAll('.js-video-popup');
    this.browseCarousel = document.querySelector('.home-browse .main-carousel');
    this.featuredCollectionCarousel = document.querySelector('.home-collections .main-carousel');
    this.featuredCollectionPrevBtn = document.querySelector(
      '.home-collections .carousel-container .prev'
    );
    this.featuredCollectionNextBtn = document.querySelector(
      '.home-collections .carousel-container .next'
    );
    this.featuredCollectionQuickview = document.querySelectorAll(
      '.home-collections button.quick-view'
    );
    this.init();
    this.initialiizeReview(products, true);

    this.openQuickViewModalBtns.forEach(button => {
      button.addEventListener('click', this.displayQuickViewModal.bind(this));
    });

    if (this.featuredCollectionQuickview) {
      this.featuredCollectionQuickview.forEach(button => {
        button.addEventListener('click', this.displayQuickViewModal.bind(this));
      });
    }
  }

  init() {
    let cellVideo = '';
    document.querySelectorAll('.js-open-main-video').forEach((element, index) => {
      element.addEventListener('click', function(event) {
        event.preventDefault();

        const dataSrc = this.dataset.src;
        const target = document.querySelector(this.hash);
        const video = target.querySelector('video');
        const videoSource = video.querySelector('source');
        cellVideo = this.closest('.carousel-cell').querySelector('.video-bg');

        target.classList.add('popup-open');
        if (video != null) {
          video.setAttribute('src', dataSrc)
          video.play();
          cellVideo.pause();
        }
      });
    });

    document.querySelectorAll('.js-close-main-video').forEach((element, index) => {
      element.addEventListener('click', function(event) {
        event.preventDefault();

        const target = document.querySelector(this.hash);
        const video = target.querySelector('video');
        cellVideo.play();

        target.classList.remove('popup-open');
        if (video != null) {
          video.pause();
        }
      });
    });

    // Pick random image for Process section
    for (var i = 0, length1 = homeProcessImages.length; i < length1; i++) {
      const processImage =
        homeProcessImages[i][Math.floor(Math.random() * homeProcessImages[i].length)];
      const processImageEl = document.querySelectorAll('.home-process')[i].querySelector('img');
      processImageEl.src = processImage.cloudinary_src + 'w_640';
      processImageEl.srcset = `
        ${processImage.cloudinary_src + 'w_1920'} 1920w,
        ${processImage.cloudinary_src + 'w_1024'} 1024w,
        ${processImage.cloudinary_src + 'w_640'} 640w,
      `;
    }

    // Initialize carousels

    for (var i = 0, length1 = this.heroCarousel.length; i < length1; i++) {
      const thisHero = this.heroCarousel[i];
      const thisPopup = this.heroVideoPopup[i];

      var mainCarousel = new Flickity(thisHero, {
        prevNextButtons: false,
        setGallerySize: false,
        pageDots: true,
        wrapAround: true,
        autoPlay: 5000,
        on: {
          ready: () => {
            setTimeout(() => {
              const slider = thisHero.querySelectorAll('.carousel-cell');

              // create prev/next
              if (slider.length > 1) {
                slider.forEach(slide => {
                  const prevButton = document.createElement('div');
                  const nextButton = document.createElement('div');
                  prevButton.className = 'pager pager-prev';
                  nextButton.className = 'pager pager-next';
                  slide.appendChild(prevButton);
                  slide.appendChild(nextButton);
                  prevButton.addEventListener('click', function() {
                    mainCarousel.previous(false, false);
                  });
                  nextButton.addEventListener('click', function() {
                    mainCarousel.next(false, false);
                  });
                });
              }
            }, 0);
          },
          change: slideIndex => {
            const slider = thisHero.querySelectorAll('.carousel-cell');

            // play the active slide video and pause every other video
            slider.forEach((element, index) => {
              const video = element.querySelector('video');
              const videoOverlay = thisPopup.querySelector('.popup__body video');

              if (video != null) {
                if (index == slideIndex) {
                  const videoSrc = video.querySelector('source').getAttribute('src');
                  videoOverlay.setAttribute('src', videoSrc);
                  video.play();

                  return;
                }

                video.pause();
              }
            });
          }
        }
      });
    }

    var flktyBrowseCarousel = new Flickity(this.browseCarousel, {
      freeScroll: true,
      contain: true,
      pageDots: false,
      groupCells: true,
      on: {
        ready: () => {
          setTimeout(() => {
            const pagers = this.browseCarousel.querySelectorAll('.flickity-prev-next-button');

            pagers.forEach(pager => {
              pager.innerHTML = `
                <svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.785645 1L7.21422 6.5L0.785645 12" stroke="#111E90" stroke-width="2"/>
                </svg>
              `;
            });
          }, 0);
        }
      }
    });

    var flktyFeaturedCarousel;
    if (this.featuredCollectionCarousel) {
      flktyFeaturedCarousel = new Flickity(this.featuredCollectionCarousel, {
        contain: true,
        groupCells: '100%',
        pageDots: false,
        prevNextButtons: false,
        setGallerySize: false,
        on: {
          ready: () => {
            setTimeout(() => {
              if (flktyFeaturedCarousel.slides.length < 2) {
                this.featuredCollectionNextBtn.classList.add('hide');
                this.featuredCollectionPrevBtn.classList.add('hide');
              }
            }, 0);
          },
          change: index => {
            // Change arrow style based on slide number
            if (index === 0) {
              this.featuredCollectionPrevBtn.classList.add('disabled');
            } else {
              this.featuredCollectionPrevBtn.classList.remove('disabled');
            }

            if (index === flktyFeaturedCarousel.slides.length - 1) {
              this.featuredCollectionNextBtn.classList.add('disabled');
            } else {
              this.featuredCollectionNextBtn.classList.remove('disabled');
            }
          }
        }
      });

      this.featuredCollectionPrevBtn.addEventListener('click', () => {
        flktyFeaturedCarousel.previous();
      });

      this.featuredCollectionNextBtn.addEventListener('click', () => {
        flktyFeaturedCarousel.next();
      });
    }
  }

  /**
   * Fetch product rating from Yotpo and display them
   */
  initialiizeReview(products, isFeatured) {
    products.forEach(product => {
      const el = document.querySelector(`#${isFeatured ? 'feat-' : ''}item-${product.id} .rating`);

      fetch(`https://api.yotpo.com/products/${yotpoKey}/${product.productId}/bottomline`)
        .then(res => {
          if (res.ok) return res.json();
          else throw Error(`Request rejected with status ${res.status}`);
        })
        .then(res => {
          if (res.hasOwnProperty('response')) {
            const { average_score, total_reviews } = res.response.bottomline;
            product.review = {
              average_score: average_score.toFixed(1),
              total_reviews: total_reviews.toLocaleString()
            };

            if (el) {
              el.innerHTML = `
                <div class="star">
                  <span>${average_score}</span>
                  <div class="yotpo bottomline">
                    <div class="yotpo-bottomline pull-left star-clickable">
                      <span class="yotpo-stars">
                        <span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="review-count">
                  ${total_reviews} Review${total_reviews > 1 ? 's' : ''}
                </div>
              `;
            }

            if (typeof Event === 'function') {
              // modern browsers
              window.dispatchEvent(new Event('resize'));
            } else {
              // for IE and other old browsers
              // causes deprecation warning on modern browsers
              var evt = window.document.createEvent('UIEvents');
              evt.initUIEvent('resize', true, false, window, 0);
              window.dispatchEvent(evt);
            }
          }
        })
        .catch(err => console.log);
    });

    if (!isFeatured) filteredProducts = products;
  }

  // --------------- Event handlers --------------- //
  /**
   * Display product quick view modal
   */
  displayQuickViewModal(e) {
    e.preventDefault();

    let target = e.target;
    while (!target.classList.contains('quick-view')) {
      target = target.parentElement;
    }

    const productId = target.dataset.productid;
    const variantId = target.dataset.variantid;
    const modal = document.getElementById(`quick-view-${productId}`);

    this.quickViewModals.previewVariant(modal, undefined, variantId);

    modal.style.display = 'flex';
  }
}
